module.exports = {"address1":"Address"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/AutocompleteInput/locales/en.json
// module id = 1193
// module chunks = 0